import { LOCATIONS } from '../actionTypes';

const initialState = {
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOCATIONS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case LOCATIONS.SELECTED:
      return {
        ...state,
        selectedLocation: action.payload,
      };
    default:
      return state;
  }
};
